export default __webpack_public_path__ + "static/media/instagram.d184794f.svg";